import './ticket.scss'
import imgTicket from '../assets/ticket.png'

const Ticket = props => {
    return <img src={ imgTicket } className="ticket-icon" alt="Ticket icon" />
}

export default Ticket